import { render, staticRenderFns } from "./ConsumerModelSection.vue?vue&type=template&id=37c528d2&scoped=true"
import script from "./ConsumerModelSection.vue?vue&type=script&lang=js"
export * from "./ConsumerModelSection.vue?vue&type=script&lang=js"
import style0 from "./ConsumerModelSection.vue?vue&type=style&index=0&id=37c528d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c528d2",
  null
  
)

export default component.exports